import { render, staticRenderFns } from "./CostSidebar.vue?vue&type=template&id=be932450&scoped=true"
import script from "./CostSidebar.vue?vue&type=script&lang=js"
export * from "./CostSidebar.vue?vue&type=script&lang=js"
import style0 from "./CostSidebar.vue?vue&type=style&index=0&id=be932450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be932450",
  null
  
)

export default component.exports